// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"e67619c7","453":"6ae337d6","656":"08c02c83","805":"a09bc71d","874":"ae0ec17e"}[chunkId] + ".chunk.js";
};